export default "__VITE_ASSET__af04329f__"